import GlobalMixin from "../GlobalMixin";
import store from "../store";

export default {
  mixins: [GlobalMixin],
  data() {
    return {
      user: store?.getters?.StateUser?.user,
      breadcrumbLinks: [
        {
          text: "chooseCourses",
          componentName: "KidsCoursesList",
          href: "courses",
        },
        {
          text: "kid’sCourses",
          componentName: "KidsCourses",
          href: "kids",
        },
        {
          text: "scheduleInterview",
          componentName: "ScheduleInterview",
          href: "interview",
        },
      ],
    };
  },
  methods: {
    /**
     * Get Kids for authenticated user
     * @returns kids
     */
    async getKidsDetails() {
      try {
        const body = {};
        const response = await this.axios.post(
          `${process.env.VUE_APP_APIEndPoint}auth/kid/list/`,
          body,
          this.headers
        );
        return await response.data;
      } catch (err) {
        this.formatErrors(err);
      }
    },

    /**
     * Save Selected courses for kids
     * @returns void
     */
    addInterestedKidsCourses() {
      const body = {
        institute: +this.user.username.at(-1),
        parent_user: this.user.id,
        delete_other_assigned_courses: true,
        interested_courses: this.$store.getters.GET_SELECTED_MATRIX,
      };

      this.axios
        .post(
          `${process.env.VUE_APP_APIEndPoint}auth/add_interested_courses/`,
          body,
          this.headers
        )
        .then(() => {});
    },

    /**
     * Get all shecules for a specific date
     * @param schedule_date date
     * @returns webinars
     */
    async getAllSchedulingDetials(schedule_date) {
      try {
        const body = {
          institute: +this.user.username.at(-1),
          schedule_date,
        };
        const response = await this.axios.post(
          `${process.env.VUE_APP_APIEndPoint}p2p/scheduling_webinars/`,
          body,
          this.headers
        );
        return await response.data.webinars;
      } catch (err) {
        this.formatErrors(err);
      }
    },
  },
};
